module.exports = __webpack_public_path__ + "static/img/A145.65b69d08.jpg";